/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/* istanbul ignore file */
export {
  FUZZY_VRM_STATIC_CODE,
  DEFAULT_PAGE_SIZE,
  GRID_CONFIG,
} from './constants'
export { GRID_FILTER_PARAMS, getGridColumns } from './gridConfig'
